export default "__VITE_ASSET__BBB8PRFw__"